exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px){.styles--onlyXs__37DbW{display:none !important}}@media (min-width: 768px){.styles--smUp__SSE82{display:none !important}}@media (max-width: 999px){.styles--mdDown__IfSzg{display:none !important}}.styles--lessonName__3Kqm6{font-weight:600;width:300px;display:block;display:-webkit-box;line-clamp:3;text-overflow:-o-ellipsis-lastline;text-overflow:ellipsis;overflow:hidden;-webkit-line-clamp:3;-webkit-box-orient:vertical;max-height:3.9em;line-height:1.3em;word-break:break-word}.styles--lessonNameMd__256PG{width:100px}.styles--lessonNameXs__19Oil{width:80px}.styles--lessonType__DfZFY{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:40px;height:40px}\n", ""]);

// exports
exports.locals = {
	"onlyXs": "styles--onlyXs__37DbW",
	"smUp": "styles--smUp__SSE82",
	"mdDown": "styles--mdDown__IfSzg",
	"lessonName": "styles--lessonName__3Kqm6",
	"lessonNameMd": "styles--lessonNameMd__256PG",
	"lessonNameXs": "styles--lessonNameXs__19Oil",
	"lessonType": "styles--lessonType__DfZFY"
};